module.exports = __webpack_public_path__ + "static/recruit_home__reason-bgr-ipad-aeded27fa0adac764f419850b47733cf.jpg";